/**
 * React Front-end for Mission.dev
 */
import "style/base.css";
import "style/fonts.css";
import "style/modals.css";

const componentRequireContext = require.context("pages", true);
const ReactRailsUJS = require("react_ujs");

ReactRailsUJS.useContext(componentRequireContext);
